import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b81ecac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "autocomplete-popup__input-container-group q-input-group q-mb-1 q-input-group-lg" }

import SearchInput from "@/components/SearchInput.vue";
import ClosePopupButton from './ClosePopupButton.vue'

import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {storeToRefs} from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'AutocompleteInputContainer',
  setup(__props) {

const popupStore = usePopupStore()
const {showAutocompletePopup} = storeToRefs(popupStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showAutocompletePopup))
      ? (_openBlock(), _createBlock(ClosePopupButton, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(SearchInput, { autocomplete: true })
  ]))
}
}

})